module.exports = __webpack_public_path__ + "static/media/tz.d3df42da.svg";